export default __webpack_public_path__ + "static/media/key.957a49aa.webp";